import { CreateApiHandler, HiverAxios } from "../helpers"
import { SET_USER_GROUP_PROPERTY } from "./types";
import {
    getConfigKey,
  } from '@hiver/hiver-config-library';

export const setUsergroupPropertyActionCreator = CreateApiHandler(({property, value}) => {
    return new Promise((res, rej) => {
        let url = '/gx/ext/setUserGroupProperty';
        const body = {
            prop: property,
            val: value ,
            email: getConfigKey('emailId')
        }
        HiverAxios({
            url,
            type: 'POST',
            params:body,
            callback:(response) => { res({...response.data, property, value}) },
            onfail: (err) => {rej(err)}
        })
    })
}, SET_USER_GROUP_PROPERTY)
